import { IoIosArrowBack } from '@react-icons/all-files/io/IoIosArrowBack';
import React from 'react';


export default function BackBtn() {

    return (
        <>
            <IoIosArrowBack/>
        </>
    )
}